import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ResetPasswordDialog({ member }) {
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState("");

  const save = async () => {
    try {
      await api.post(`/team/${member.id}/password`, { password: pw });
      toast.success(`Password reset for ${member.name}`);
      setOpen(false);
      setPw("");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <>
      <Button data-testid={`team-reset-${member.id}`} variant="outline" onClick={() => setOpen(true)}
        className="h-9 gap-1.5 border-slate-700 bg-slate-950 px-3 text-xs text-slate-200 hover:bg-slate-800">
        <KeyRound className="h-3.5 w-3.5" /> Reset password
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="team-reset-dialog" className="border-slate-800 bg-slate-900 text-slate-100 sm:max-w-[400px]">
          <DialogHeader><DialogTitle>New password for {member.name}</DialogTitle></DialogHeader>
          <Input data-testid="team-reset-input" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Min 8 characters"
            className="border-slate-700 bg-slate-950 font-data" />
          <Button data-testid="team-reset-save" onClick={save} disabled={pw.length < 8} className="bg-[#A0148C] font-bold hover:bg-[#80106F]">
            Set password
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
